import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import StudentPage from './pages/StudentPage';
import TeacherPage from './pages/TeacherPage';
import AdminPage from './pages/AdminPage';
import DemoPage from './pages/DemoPage';

// 体験版は開始から2時間で終わる（ブラウザに体験版の記録が残り続けて、本番に入れなくなるのを防ぐ）
const DEMO_LIMIT_MS = 2 * 60 * 60 * 1000;

function clearDemo() {
  ['token', 'role', 'userInfo', 'isDemo', 'demoAt'].forEach(k => localStorage.removeItem(k));
}

function ProtectedRoute({ element, requiredRole }) {
  const isDemo = localStorage.getItem('isDemo') === 'true';

  // 古い体験版の記録（開始時刻がない＝2026-09-19より前の体験版も含む）はここで終わらせてログイン画面へ
  if (isDemo && Date.now() - (Number(localStorage.getItem('demoAt')) || 0) > DEMO_LIMIT_MS) {
    clearDemo();
    return <Navigate to="/login" />;
  }

  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');

  // デモユーザーが教師・児童以外にアクセスしようとした場合は/demoに戻す
  if (isDemo && requiredRole === 'admin') {
    return <Navigate to="/demo" />;
  }

  if (!token || (requiredRole && role !== requiredRole)) {
    localStorage.clear();
    return <Navigate to="/login" />;
  }

  return element;
}

function LoginRoute() {
  // 体験版を試したあとでも本番にログインできるよう、体験版の記録を消してログイン画面を出す
  // （以前は /demo へ戻していたため、一度体験版を開いたブラウザではログイン画面に行けなかった）
  if (localStorage.getItem('isDemo') === 'true') clearDemo();
  return <LoginPage />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<LoginRoute />} />
        <Route path="/student" element={<ProtectedRoute element={<StudentPage />} requiredRole="student" />} />
        <Route path="/teacher" element={<ProtectedRoute element={<TeacherPage />} requiredRole="teacher" />} />
        <Route path="/admin" element={<ProtectedRoute element={<AdminPage />} requiredRole="admin" />} />
        <Route path="/demo" element={<DemoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
